import React from 'react';
import LegalLayout, { LegalH2, LegalH3, LegalUL, COMPANY } from '../../components/LegalLayout';

const CookiePolicy = () => (
  <LegalLayout title="Cookie Policy" lastUpdated="May 11, 2026">
    <p>
      This Cookie Policy explains how {COMPANY.name} ("<strong>NoFee</strong>") uses cookies and similar technologies
      on <strong>nofee.restaurant</strong> and the NoFee Service.
    </p>

    <LegalH2>1. What Are Cookies?</LegalH2>
    <p>Cookies are small text files placed on your device by websites you visit. They are widely used to make websites
      work, improve user experience, and provide analytics. We also use similar technologies such as local storage,
      session storage, and pixels.</p>

    <LegalH2>2. Categories of Cookies We Use</LegalH2>

    <LegalH3>2.1 Strictly Necessary (always on)</LegalH3>
    <p>Required for the Service to function. Cannot be disabled without breaking core features.</p>
    <LegalUL>
      <li><code className="text-gold-300">nofee_token</code> — restaurant authentication session;</li>
      <li><code className="text-gold-300">nofee_amb_token</code> — ambassador authentication session;</li>
      <li>CSRF protection cookies;</li>
      <li>Load-balancer routing cookies.</li>
    </LegalUL>

    <LegalH3>2.2 Functional</LegalH3>
    <p>Remember preferences like language, region, and UI settings.</p>
    <LegalUL>
      <li>Selected display language (EN / ES / PT);</li>
      <li>Cookie consent preferences (so we don&apos;t ask you again).</li>
    </LegalUL>

    <LegalH3>2.3 Performance &amp; Analytics</LegalH3>
    <p>Help us understand how the Service is used. Aggregated and anonymized where possible.</p>
    <LegalUL>
      <li><strong>Sentry</strong> — error monitoring and performance traces (captures stack traces, timing, basic
        environment info; does NOT capture passwords, payment details, or full request bodies);</li>
      <li>Session replay (when enabled) — records user interactions to debug bugs. Sensitive inputs are automatically masked.</li>
    </LegalUL>

    <LegalH3>2.4 Marketing</LegalH3>
    <p>We currently do <strong>not</strong> use third-party advertising cookies. If we add them in the future, you will
      be asked for consent and this policy will be updated.</p>

    <LegalH2>3. Third-Party Cookies</LegalH2>
    <p>The following third parties may set cookies via the Service:</p>
    <LegalUL>
      <li><strong>Stripe</strong> — payment processing (set on checkout pages);</li>
      <li><strong>Sentry</strong> — error monitoring;</li>
      <li><strong>Cloudflare</strong> — DDoS protection and CDN.</li>
    </LegalUL>

    <LegalH2>4. Managing Your Cookie Choices</LegalH2>
    <LegalUL>
      <li>When you first visit the Service, you may see a cookie banner allowing you to accept or reject non-essential cookies.</li>
      <li>You can change your choice at any time by clearing your browser&apos;s cookies and revisiting the site.</li>
      <li>You can disable cookies in your browser settings (Chrome, Safari, Firefox, Edge all offer this). Note that
        disabling Strictly Necessary cookies will break core functionality (login, ordering, etc.).</li>
      <li>For Do Not Track signals: we currently do not respond to DNT headers, as there is no industry-wide standard.</li>
    </LegalUL>

    <LegalH2>5. Cookie Lifespan</LegalH2>
    <LegalUL>
      <li><strong>Session cookies</strong> — deleted when you close your browser;</li>
      <li><strong>Persistent cookies</strong> — remain until expiration or you delete them. Authentication tokens
        typically last 7 days (restaurants) or 30 days (ambassadors).</li>
    </LegalUL>

    <LegalH2>6. Changes to This Policy</LegalH2>
    <p>We may update this Cookie Policy as we add or remove cookies. The "Last updated" date at the top reflects the
      most recent revision.</p>

    <LegalH2>7. Contact</LegalH2>
    <p>Questions about cookies? Email{' '}
      <a href="mailto:support@nofee.restaurant" className="text-gold-400 hover:text-gold-300">support@nofee.restaurant</a>.</p>
  </LegalLayout>
);

export default CookiePolicy;
